import { Injectable } from "@angular/core";
import Clarity from "@microsoft/clarity";
import { environment } from "src/environments/environment.development";
// import {environment} from 'src/environments/environment'

@Injectable({
    providedIn: "root",
})
export class ClarityService {
    private initialized = false; // flag to prevent multiple initialize

    init(): void {
        if (this.initialized || !environment.production) {
            return;
        }
        Clarity.init(environment.clarityProjectId);
        this.initialized = true;
    }

    identify(userId: string, sessionId?: string, pageId?: string,friendlyName?: string) {
        Clarity.identify(userId,sessionId, pageId,friendlyName);
    }
    setTag(key: string, value: string | string[]): void {
        Clarity.setTag(key, value);
    }

    event(name: string): void {
        Clarity.event(name);
    }

    consent(consentGiven = true): void {
        Clarity.consent(consentGiven);
    }
}
